import { http } from "@/core/api/";

const booksBaseURL = "api/books";

export const getStudentBooksOrdersYears = async studentSieId => {
  return await http.get(
    `${booksBaseURL}/studentbookorderyears/${studentSieId}`
  );
};

export const getStudentBooksOrders = async (studentSieId, academicYearId) => {
  return await http.get(`${booksBaseURL}/studentbookorders`, {
    params: {
      studentSieId: studentSieId,
      academicYearId: academicYearId
    }
  });
};

export const getAcademicYears = () => {
  return http.get(
    "api/academicyears/academicyearfromin?minYearId=25&yearType=current"
  );
};

export const getAcademicYearsForBooksOrder = () => {
  return http.get(
    "api/academicyears/academicyearfromin?minYearId=19&yearType=future"
  );
};

export const getBooksForOrders = async filters => {
  return await http.get(`${booksBaseURL}/booksfororders`, {
    params: {
      academicYearId: filters.academicYearId,
      searchField: filters.searchField,
      studentSieId: filters.studentSieId,
      pageSize: filters.pageSize,
      pageIndex: filters.pageIndex
    }
  });
};

export const assignBookToStudent = async book => {
  return await http.post(`${booksBaseURL}/assigntostudent`, book);
};

export const getStudentPendingBooksOrders = async (
  studentSieId,
  academicYearId
) => {
  return await http.get(
    `${booksBaseURL}/studentpendingbookorders/${studentSieId}/${academicYearId}`
  );
};

export const removeOrder = async book => {
  return await http.post(`${booksBaseURL}/removeorder`, book);
};

export const documentBookOrder = async book => {
  return await http.post(`${booksBaseURL}/documentbookorder`, book);
};

export const documentBooksOrders = async books => {
  return await http.post(`${booksBaseURL}/documentbookorders`, books);
};

export const submit = async selectedBooks => {
  return await http.post(`${booksBaseURL}/submit`, selectedBooks);
};

export const getStatusList = async () => {
  return await http.get(`${booksBaseURL}/statuses`);
};

export const manage = async filters => {
  return await http.get(`${booksBaseURL}/manage`, {
    params: {
      academicYearId: filters.academicYearId,
      statusId: filters.statusId,
      searchField: filters.searchField,
      centerId: filters.centerId,
      municipalityId: filters.municipalityId,
      schoolId: filters.schoolId,
      subjectId: filters.subjectId,
      gradeId: filters.gradeId,
      readingMediumId: filters.readingMediumId,
      pageIndex: filters.pageIndex
    }
  });
};

export const determineBook = async book => {
  return await http.post(`${booksBaseURL}/determine`, book);
};

export const getBooksPublishers = async () => {
  return await http.get(`${booksBaseURL}/publishers`);
};

export const getCatalog = async filters => {
  return await http.get(`${booksBaseURL}/catalog`, {
    params: {
      publisherId: filters.publisherId,
      searchField: filters.searchField,
      subjectId: filters.subjectId,
      gradeId: filters.gradeId,
      readingMediumId: filters.readingMediumId,
      pageIndex: filters.pageIndex
    }
  });
};

export const getBook = async filters => {
  return await http.get(`${booksBaseURL}/${filters.bookId}`);
};

export const addBook = async book => {
  return await http.post(`${booksBaseURL}/add`, book);
};

export const editBook = async book => {
  return await http.put(`${booksBaseURL}/edit`, book);
};

export const getOrderHistory = async params => {
  return await http.get(`${booksBaseURL}/orderhistory`, {
    params
  });
};

export const getBooksAuthors = async () => {
  return await http.get(`${booksBaseURL}/authors`);
};

export const undoStatus = async book => {
  return await http.post(`${booksBaseURL}/undostatus`, book);
};

export const deleteBook = async bookId => {
  return await http.put(`${booksBaseURL}/delete/${bookId}`);
};

export const getBookAvailability = async (bookId, academicYearId) => {
  return await http.get(
    `${booksBaseURL}/availability/${academicYearId}/${bookId}`
  );
};
